import type { Directive } from 'vue'

// Наблюдатель нужен и в unmounted, а второго аргумента у хука нет. WeakMap, а не
// свойство на элементе: узел уходит из карты вместе с собой, чистить нечего.
const observers = new WeakMap<HTMLElement, IntersectionObserver>()

/**
 * v-reveal — одноразовое появление блока при попадании во вьюпорт (DEV-1812).
 *
 * ⚠ КЛАСС 'reveal' (opacity: 0) СТАВИТСЯ ТОЛЬКО ОТСЮДА, ИЗ mounted, И НИКОГДА НЕ
 * ПИШЕТСЯ В РАЗМЕТКЕ. В шаблоне он означал бы, что при выключенном или упавшем JS
 * страница останется прозрачной — контента не увидит ни человек, ни краулер.
 * Не «оптимизировать» обратно в статический класс шаблона.
 *
 * Наблюдатель отключается на первом же пересечении: эффект одноразовый, иначе
 * секция мигала бы при каждом возврате скролла.
 */
export const vReveal: Directive<HTMLElement> = {
  mounted(el) {
    // Старый браузер или jsdom: наблюдателя нет — оставляем контент видимым.
    if (typeof IntersectionObserver === 'undefined') return

    el.classList.add('reveal')

    const observer = new IntersectionObserver(
      entries => {
        if (!entries.some(entry => entry.isIntersecting)) return

        el.classList.add('reveal-in')
        observer.disconnect()
      },
      // -10% снизу: блок проявляется, когда заметно вошёл в экран, а не краем.
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    )

    observer.observe(el)
    observers.set(el, observer)
  },

  unmounted(el) {
    // Блок, который сняли до пересечения, иначе держал бы наблюдатель живым.
    observers.get(el)?.disconnect()
    observers.delete(el)
  },
}
